type RewardPillProps = {
  reward: string;
  flex?: boolean;
};

export const RewardPill = ({ reward, flex = true }: RewardPillProps) => {
  return (
    <div
      className={`tw-flex tw-h-[26px] tw-min-w-0 tw-items-center tw-justify-center tw-rounded-[50px] tw-border-[2px] tw-border-solid tw-border-[#20AA67] tw-px-[10px] ${
        flex ? 'tw-flex-1' : ''
      }`}
      style={{
        background: 'rgba(32, 170, 103, 0.20)',
      }}
    >
      <span className="tw-truncate tw-font-jost tw-text-[12px] tw-uppercase tw-leading-[30px] tw-text-white">
        {reward}
      </span>
    </div>
  );
};
